import { render, staticRenderFns } from "./apartmentCard.vue?vue&type=template&id=ded5826e&scoped=true&"
import script from "./apartmentCard.vue?vue&type=script&lang=js&"
export * from "./apartmentCard.vue?vue&type=script&lang=js&"
import style0 from "./apartmentCard.vue?vue&type=style&index=0&id=ded5826e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded5826e",
  null
  
)

export default component.exports